module.exports = __webpack_public_path__ + "img/alerts-2.3ea55412.gif";